module.exports = "/_next/static/images/rabbit-6bb0fe073752926221eb7cabd08ed5eb.svg";